import { CurrentAcIcon } from './CurrentAcIcon';

/**
 * author: Michael Irigoyen
 * id BB0EDAF7-B538-4DAA-8406-36470F472EA1
 * name current-ac
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/current-ac.svg
 * tags
 */
export const AlternatingCurrentIcon = CurrentAcIcon;
export default AlternatingCurrentIcon